import { NOTIFICATION_CATEGORY } from "@nlc/shared-types";

export const categoryNameMapper: Record<NOTIFICATION_CATEGORY, string> = {
  [NOTIFICATION_CATEGORY.COMMENT_ADDED]: "Comment is added",
  [NOTIFICATION_CATEGORY.DUE_DATE]: "Due date is updated",
  [NOTIFICATION_CATEGORY.FEEDBACK_RECEIVED]: "Feedback received",
  [NOTIFICATION_CATEGORY.FEEDBACK_TOOL]: "Feedback tool is updated",
  [NOTIFICATION_CATEGORY.I_AM_MENTIONED]: "I am mentioned",
  [NOTIFICATION_CATEGORY.ISSUE_IS_REPORTED]: "Issue is reported",
  [NOTIFICATION_CATEGORY.REQUEST_ASSIGNED]: "Request is assigned to you",
  [NOTIFICATION_CATEGORY.REQUEST_CREATED]: "Request is created",
  [NOTIFICATION_CATEGORY.REQUEST_UPDATED]: "Request updated",
  [NOTIFICATION_CATEGORY.STATUS_UPDATED]: "Status is updated",
  [NOTIFICATION_CATEGORY.UPDATES_FROM_REQUESTS_CREATED_BY_OTHERS]:
    "Updates from requests created by others",
};
